<template>
  <x-page title="评价" :loading="loading">
    <x-card
      v-for="goods in orderData.commodities"
      :key="goods.skuId"
      class="item"
    >
      <div class="hd">
        <van-image :src="goods.pic" fit="cover" class="cover" />
        <div class="content">
          <div :class="['name', _._ellipsis2]">
            {{ goods.name }}
          </div>
          <div class="desc">
            {{ goods.skuSpecs }}
          </div>
        </div>
      </div>

      <div class="bd">
        <div class="rate">
          <div class="label">商品评分</div>
          <van-rate
            v-model="commentData[goods.skuId].evaluateStar"
            class="star"
            color="#FF0F2A"
            void-icon="star"
            void-color="#D8D8D8"
            @change="() => (commentData[goods.skuId].label = [])"
          />
          <div class="text">
            {{ goods.starToText[commentData[goods.skuId].evaluateStar] }}
          </div>
        </div>
        <div class="tags">
          <div
            v-for="tag in goods.starToTags[
              commentData[goods.skuId].evaluateStar
            ]"
            :key="tag"
            :class="[
              'tag',
              commentData[goods.skuId].label.includes(tag) && 'selected',
            ]"
            @click="handleTagClick(goods, tag)"
          >
            {{ tag }}
          </div>
        </div>
        <van-field
          v-model="commentData[goods.skuId].evaluateContent"
          v-fix-keyboard
          class="desc"
          type="textarea"
          rows="3"
          placeholder="多个维度评价商品，可以帮助更多想买的人"
          maxlength="200"
          show-word-limit
        />
        <x-image-picker
          v-model="commentData[goods.skuId].evaluatePic"
          class="upload"
          :limit="6"
          placeholder="买家秀"
        />
      </div>
    </x-card>

    <div class="actions">
      <x-button
        v-track="{
          name: '我的订单-评价-发布',
          id: '879a5ef4-c3f2-472b-9f73-654728510961',
        }"
        @click="handleSubmitClick"
      >
        发布
      </x-button>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiEvaluationEvaluateLabelTemplateGetLabelList,
    apiEvaluationEvaluateSubmit,
    apiOrderOrderDetail,
  } from '@/api'
  import { mapQuery, prepareData, submit, Track } from '@/utils'
  import { navigateBack } from '@/router'
  import { values } from 'vtils'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      mapQuery({
        // 订单号
        orderNo: 'orderNo',
      }),
      Track.provideMark(() => ({
        page: '评价',
      })),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,

      // 订单数据
      orderData: {},

      // 评价数据
      commentData: {},
    }),

    async mounted() {
      const { orderData } = await prepareData({
        orderData: apiOrderOrderDetail({
          orderNo: this.orderNo,
        }).then(async res => {
          res.commodities = await Promise.all(
            res.commodities.map(async goods => {
              goods.starToTags =
                await apiEvaluationEvaluateLabelTemplateGetLabelList({
                  commodityCategoryId: goods.categoryId,
                }).then(data => {
                  return data.reduce(
                    (res, item) => {
                      res[item.star] = item.labelContent
                      return res
                    },
                    {
                      0: [],
                      1: [],
                      2: [],
                      3: [],
                      4: [],
                      5: [],
                    },
                  )
                })
              goods.starToText = {
                0: '',
                1: '非常差',
                2: '较差',
                3: '一般',
                4: '好',
                5: '非常好',
              }
              return goods
            }),
          )
          return res
        }),
      })
      this.orderData = orderData
      this.commentData = orderData.commodities.reduce((res, goods) => {
        res[goods.skuId] = {
          commodityServiceId: goods.commodityId,
          commodityServiceName: goods.name,
          commodityServiceSpecs: goods.skuSpecs,
          evaluateContent: '',
          evaluatePic: [],
          evaluateStar: 0,
          label: [],
          orderAmount: orderData.orderAmount,
          refOrderNo: orderData.orderNo,
        }
        return res
      }, {})
      this.loading = false
    },

    methods: {
      // 点击标签
      handleTagClick(goods, tag) {
        const tagIndex = this.commentData[goods.skuId].label.indexOf(tag)
        if (tagIndex === -1) {
          this.commentData[goods.skuId].label.push(tag)
        } else {
          this.commentData[goods.skuId].label.splice(tagIndex, 1)
        }
      },

      // 点击提交
      async handleSubmitClick() {
        await submit(async $ => {
          const commentData = values(this.commentData).map(item => ({
            ...item,
            label: item.label.join(','),
          }))
          if (commentData.some(item => !item.evaluateStar)) {
            return $.fail('请为所有商品评分')
          }
          await $.start('评价中...')
          await apiEvaluationEvaluateSubmit({
            list: commentData,
          })
          await $.success('评价成功')
          navigateBack()
        })
      },
    },
  })
</script>

<style lang="scss" scoped>
  .item {
    .hd {
      display: flex;

      .cover {
        flex-shrink: 0;
        width: 85px;
        height: 85px;
        border-radius: 8px;
        overflow: hidden;
      }

      .content {
        margin-left: 12px;

        .name {
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }

        .desc {
          margin-top: 8px;
          font-size: 12px;
          color: #888888;
        }
      }
    }

    .bd {
      margin-top: 16px;

      .rate {
        display: flex;
        align-items: center;

        .label {
          font-size: 14px;
          color: #222222;
          margin-bottom: -1px;
        }

        .star {
          margin-left: 12px;

          ::v-deep .van-rate__icon {
            font-size: 20px;
          }
        }

        .text {
          margin-left: 20px;
          font-size: 14px;
          font-weight: bold;
          color: #ff111c;
        }
      }

      .tags {
        margin-top: 8px;
        margin-left: -8px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .tag {
          margin-top: 8px;
          margin-left: 8px;
          background: #f5f6f8;
          font-size: 12px;
          color: #222222;
          padding: 4px 12px;
          border-radius: 1000px;

          &.selected {
            background-color: #fff2f1;
            color: #ff111c;
          }

          &:active {
            opacity: 0.8;
          }
        }
      }

      .desc {
        margin-top: 16px;
        background: #f5f6f8;
        border-radius: 8px;

        ::v-deep {
          .van-field__control {
            &::placeholder {
              color: #999;
            }
          }

          .van-field__word-limit {
            color: #999;
          }
        }
      }

      .upload {
        margin-top: 16px;
      }
    }
  }

  .actions {
    padding: 12px;
  }
</style>
